module.exports = __webpack_public_path__ + "src/images/products/allAmerican/71_Shadow Stripe T-Shirt.png";